// extracted by mini-css-extract-plugin
export default {"btnAddUser":"Users_btnAddUser__lHVIU","icon":"Users_icon__nRo91","actionIcons":"Users_actionIcons__-P35E","leftBorder":"Users_leftBorder__kPI+u"};